export const SuspectPhotoListEnum = {
  /**全部 */
  ALL: null,
  /**是 */
  Y: "Y",
  /**否 */
  N: "N",
};

/**是否含可疑照片list */
export const SuspectPhotoListOption = [
  { name: "全部", value: SuspectPhotoListEnum.ALL },
  { name: "是", value: SuspectPhotoListEnum.Y },
  { name: "否", value: SuspectPhotoListEnum.N },
];

export const isReportEnum = {
  /**未上报 */
  N: "N",
  /**已上报 */
  Y: "Y",
};

export const isReportMap = {
  [isReportEnum.N]: {
    text: "未上报",
    style: {
      color: "#FB2323",
      backgroundColor: "#FFF2F4",
      border: "1px solid #FFDBE0",
    },
    bageStyle: {
      color: "#fff",
      backgroundColor: "#FB2323",
    },
  },
  [isReportEnum.Y]: {
    text: "已上报",
    style: {
      color: "#212121",
      backgroundColor: "#F5F5F5",
      border: "1px solid #D9D9D9 ",
    },
    bageStyle: {
      color: "#fff",
      backgroundColor: "#666",
    },
  },
};

export const ReportTypeEnum = {
  /**待审核 1*/
  WAIT_AUDIT: "1",
  /**AI纠正 2 */
  AI: "2",
  /**人工反馈 3*/
  MANUAL: "3",
};

/**排序规则枚举 */
export const OrderByRuleEnum = {
  /**全部 */
  ALL: null,
  /**姓名和录入时间正序 */
  NAME_ASC: "1",
  /**姓名和录入时间倒序 */
  NAME_DESC: "2",
};

/**排序规则选项 */
export const OrderByRuleOption = [
  { name: "姓名与日期组合正序", value: OrderByRuleEnum.NAME_ASC },
  { name: "姓名与日期组合倒序", value: OrderByRuleEnum.NAME_DESC },
];
